import { handleSiteLoader } from "./authAction";
import { axiosAuth, axiosUnauth } from "../../utils/axios/axios";
import { config, errToast } from "../../utils";
import { handleFaqData } from "../slice/faqSlice";
import { toast } from "react-toastify";

export const handleFaq = (formData) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;

        try {
            const response = await (
                isAuthenticated ? axiosAuth : axiosUnauth
            ).post(`/api-faq/faq-listing/`, formData, config);
            if (response.status === 200 && response.data.error === 0) {
                dispatch(handleFaqData(response.data.data));
                dispatch(handleSiteLoader(false));
            } else toast.error(response.data.msg);
            dispatch(handleSiteLoader(false));
            return response;
        } catch (err) {
            errToast(err);
            dispatch(handleSiteLoader(false));
        }
    };
};

export const listWithUs = (formData, t) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const isAuthenticated = getState().auth.isAuthenticated;

        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                "/api-property/add-list-property-auction-request/",
                formData,
                config
            );
            const { data } = res;
            if (data.error === 0) {
                toast.success(
                    t(
                        "Thanks for reaching out! We’ll contact you shortly regarding your property."
                    )
                );
            }
            dispatch(handleSiteLoader(false));
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};
